import ibrahim from '@/assets/images/team/Ibrahim.webp'
import Twaigri from '@/assets/images/team/twafri.webp'
import Boguous from '@/assets/images/team/bogous.webp'

export const teamData = [

  {
    "img": "https://static.wixstatic.com/media/d82902_f1b671ee69b641efa51277d61a2a4e68~mv2.jpg/v1/fill/w_574,h_646,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/WhatsApp%20Image%202023-11-04%20at%2022_49_37_2c90d732.jpg",
    "name": "Mr. Khalid AlFadhli",
    "subName": "Chief Executive Officer",
    "socials": {
      "linkedin" : "",
      "Twitter" : "https://x.com/jeddah9000?s=11",
      "instegram" : ""
    }
  },
  {
    "img": "https://static.wixstatic.com/media/d82902_98a0e0c19fd24fd39497b145c3d01329~mv2.jpg/v1/fill/w_574,h_646,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/WhatsApp%20Image%202023-11-04%20at%2022_40_edited.jpg",
    "name": "Mr. Atef Al-Areshi",
    "subName": "General Manager",
    "socials": {
      "linkedin" : "https://www.linkedin.com/in/atef12234/",
      "Twitter" : "https://x.com/atef12234",
      "instegram" : ""
    }
  },
  {
    "img": ibrahim,
    "name": "Dr. Ibrahim Al Hussain",
    "subName": "FO-CEO",
    "socials": {
      "linkedin" : "https://www.linkedin.com/in/dr-ibrahim-hussain-790339160/",
      "Twitter" : "https://x.com/alcont25",
      "instegram" : ""
    }
  },
  {
    "img": Twaigri,
    "name": "Eng. Abdulaziz Al-Tuwaijri",
    "subName": "Public Relations Manager",
    "socials": {
      "linkedin" : "https://www.linkedin.com/in/abdulaziz-altuwayjiri-emba-pmp%C2%AE-613161185?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      "Twitter" : "https://x.com/altuwaijre?s=11",
      "instegram" : ""
    }
  },
  {
    "img": "https://static.wixstatic.com/media/d82902_7b647faf48f74722bb4758c951600ec5~mv2.jpg/v1/fill/w_574,h_646,al_c,lg_1,q_85,enc_avif,quality_auto/WhatsApp%20Image%202023-11-04%20at%2022_22_edited.jpg",
    "name": "Mr. Talal Kalid",
    "subName": "Project Manager",
    "socials": {
      "linkedin" : "https://www.linkedin.com/in/talal-khalid-574843245/",
      "Twitter" : "",
      "instegram" : ""
    }
  },
  {
    "img": Boguous,
    "name": "Dr. Abdulaziz Boqous",
    "subName": "Investor Relations Manager",
    "socials": {
      "linkedin" : "",
      "Twitter" : "",
      "instegram" : ""
    }
  }
]
